module.exports = __webpack_public_path__ + "img/ltkbump-4x.0218b91.jpg";